import { gql } from 'apollo-angular';

const  DISQUALIFY_SELLER = gql`
  mutation disqualifySeller($rfpId: Long!, $sellerIds: [Long!]!) {
    disqualifySeller(disqualifySellerRequest: { rfpId: $rfpId, sellerIds: $sellerIds }) {
      recipients {
        status
        seller {
          id
          name
        }
      }
    }
  }
`;

export default  DISQUALIFY_SELLER;
